import { useEffect, useMemo } from "react";
import { AdditiveBlending, Color, MeshStandardMaterial, EdgesGeometry, LineBasicMaterial, LineSegments, Object3D } from "three";
import { findObjectStartsWithKey } from "../../../../../utils/FindObjects";

const Recooling = ({ object3d, ...props }) => {
  const object = useMemo(() => {
    return findObjectStartsWithKey("EFD_Hardline_recooling", object3d);
  }, []);

  const mat = useMemo(() => {
    return new MeshStandardMaterial({
      // color: new Color("#E31E26"),
      color: new Color("#1ea5e3"),
      transparent: true,
      opacity: 0.3,
      depthWrite: false,
      depthTest: false,
      metalness: 0.1,
      roughness: 0.8,
      blending: AdditiveBlending,
      // emissive: 0xff0000,
    });
  }, []);

  useEffect(() => {
    if (object) {
      object.traverse((c) => {
        if (c.isMesh) {
          c.material = mat;
          c.renderOrder = 2;
        }
      });
    }
  }, [object]);

  const wireframeGeometry = useMemo(() => {
    var wireFrameGroup = new Object3D();

    object.traverse((c) => {
      if (c.isMesh) {
        var edges = new EdgesGeometry(c.geometry, 15);

        const mat = new LineBasicMaterial({
          color: new Color("#ffffff"),
          opacity: 0.05,
          depthTest: false,
          depthWrite: false,
          transparent: true,
          blending: AdditiveBlending,
        });

        let line = new LineSegments(edges, mat);
        line.computeLineDistances();
        line.renderOrder = 3;
        line.visible = true;

        line.position.copy(c.parent.position);

        wireFrameGroup.add(line);
      }
    });

    return wireFrameGroup;
  }, [object]);

  useEffect(() => {
    object.visible = true;
    return () => {
      object.visible = false;
    };
  }, []);

  return (
    <group>
      {/* <Clone object={object} /> */}
      <primitive object={wireframeGeometry} />
    </group>
  );
};

export default Recooling;
